import { atom } from "jotai";

import type { BusinessFilters } from "@repo/utils";

export {
  type RangeFilter,
  type BusinessFilters,
  URL_KEYS,
  getSearchParams,
  updateSearchParams,
  readFromSearchParams,
  readFromSavedSearch,
  savedSearchToSearchParams,
} from "@repo/utils";

export const businessFiltersAtom = atom<BusinessFilters>({
  location: null,
  businessTypeIds: [],
  statuses: [],
  listedBy: [],
  saleTypes: [],
  priceRange: { min: null, max: null },
  revenueRange: { min: null, max: null },
  profitRange: { min: null, max: null },
  sdeRange: { min: null, max: null },
  sdeMultipleRange: { min: null, max: null },
  revenueMultipleRange: { min: null, max: null },
  downPaymentRange: { min: null, max: null },
  establishmentAgeRange: { min: null, max: null },
  employeeCountRange: { min: null, max: null },
  ownerWorkedHoursRange: { min: null, max: null },
  propertyIncluded: null,
  financingAvailable: null,
  sbaPrequalified: null,
  visaQualified: null,
  includeMissingMultiples: true,
  priceDirection: null,
  priceChangedWithinDays: null,
  minPriceChangePercent: null,
});

export const businessMapBoundsAtom = atom<{
  sw: { lat: number; lng: number };
  ne: { lat: number; lng: number };
} | null>(null);
